import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const CorpoModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 40px;
  max-width: 450px;
`

export const ContainerDosBotoes = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 15px;
  margin-top: 20px;
`

export const ContainerObservacao = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  text-align: left;
`

export const ContadorObservacao = styled.span`
  align-self: flex-end;
  margin-top: 4px;
  font-size: 11px;
  color: ${Cores.CINZA_2_CLARO};
`
